var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientProfileWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#22b3b3"
    },
    cx: 19.1,
    cy: 11.45,
    r: 6.56,
    transform: "translate(1.21 24.72) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9d00"
    },
    d: "M34.61,31.89,27.79,20.16a2.15,2.15,0,0,0-3.69,0L17.28,31.89A2.08,2.08,0,0,0,19.13,35H32.74A2.09,2.09,0,0,0,34.61,31.89ZM26.15,21.76c.78,0,1.18.7,1.18,2.14A21.56,21.56,0,0,1,27,27.13a12,12,0,0,1-.52,2.5c-.1.2-.19.3-.34.3a.37.37,0,0,1-.37-.25,11.76,11.76,0,0,1-.51-2.33,26.68,26.68,0,0,1-.35-3.43C24.92,22.46,25.34,21.76,26.15,21.76ZM27,32.87a1.27,1.27,0,0,1-1.77,0,1.22,1.22,0,0,1,0-1.75,1.22,1.22,0,0,1,.88-.36,1.25,1.25,0,0,1,.89.38,1.15,1.15,0,0,1,0,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#22b3b3"
    },
    d: "M15,31.48l7.29-12.56a18.73,18.73,0,0,1-1.95.87,5.48,5.48,0,0,1-2.41.13c-1.59-.45-2.92-1.91-4.25-1.4a11,11,0,0,0-2.79,1.72A15.27,15.27,0,0,0,5.38,32.1c0,1.88,4.43,2,9.73,1.93A2.26,2.26,0,0,1,15,31.48Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientProfileWarning);
export default __webpack_public_path__ + "static/media/client-profile-warning.ad6f21d8d6a065c0207dd58df757b85c.svg";
export { ForwardRef as ReactComponent };